import { Platform } from 'react-native';
import * as Device from 'expo-device';
import useResponsiveness from './useResponsiveness';

// A phone or tablet requesting a wide viewport still isn't a desktop browser.
export default function useDeckAvailability() {
  const { isXS } = useResponsiveness();
  const nav = Platform.OS === 'web' && typeof navigator !== 'undefined' ? navigator : {};
  const mobileBrowser = nav.userAgentData?.mobile
    || /Mobi|Android|iPhone|iPad|iPod/i.test(nav.userAgent || '')
    || (/Macintosh/i.test(nav.userAgent || '') && (nav.maxTouchPoints || 0) > 1);
  return Platform.OS === 'macos' || (Platform.OS === 'web' && !isXS
    && !mobileBrowser
    && Device.deviceType !== Device.DeviceType.PHONE
    && Device.deviceType !== Device.DeviceType.TABLET);
}
